module.exports = __webpack_public_path__ + "img/3_14.207318e3.png";